<app-small-tuile
  type="icon"
  icon="fa-kit fa-picto-filtration"
  [title]="'dashboard.filtration' | translate"
  [content]="
    getButtons()[this.actionStack!.getValue('pvCModeFonctionnement')].icon!
  "
  [color]="
    getButtons()[this.actionStack!.getValue('pvCModeFonctionnement')].color!
  "
  [status]="getStatus() | translate"
  [mode]="
    this.actionStack!.getValue('pvCModeFonctionnement') === 1
      ? (P00058ProgrammeFiltrationManuel[
          this.actionStack!.getValue('pvCProgrammeManuel')
        ].value | translate)
      : this.actionStack!.getValue('pvCModeFonctionnement') === 2
        ? (P00058ProgrammeFiltrationAuto[
            this.actionStack!.getValue('pvCProgrammeAuto')
          ].value | translate)
        : ''
  "
  [statusMode]="
    getButtons()[this.actionStack!.getValue('pvCModeFonctionnement')].status!
  "
  (onPress)="this.openProductModal()"
>
</app-small-tuile>
